module.exports = __webpack_public_path__ + "static/media/парк.76e10f20.jpg";